var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 96,
    height: 96,
    rx: 8,
    fill: "#E3EEF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 42.5V52.5",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67.3201H35.88C28.94 67.3201 26.04 62.3601 29.4 56.3001L35.64 45.0601L41.52 34.5001C45.08 28.0801 50.92 28.0801 54.48 34.5001L60.36 45.0801L66.6 56.3201C69.96 62.3801 67.04 67.3401 60.12 67.3401H48V67.3201Z",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.989 58.5H48.007",
    stroke: "#202224",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.48ee1877f4f0233c1661f1742779c270.svg";
export { ForwardRef as ReactComponent };